// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VueLazyload from "vue-lazyload";
import VueJsonp from "vue-jsonp";
import axios from "axios";
import VueAwesomeSwiper from "vue-awesome-swiper";
import Swiper6, { Navigation, Pagination, EffectFade, Autoplay } from "swiper";

Swiper6.use([Navigation, Pagination, EffectFade, Autoplay]);

Vue.use(VueJsonp);
Vue.use(VueAwesomeSwiper);

//图片懒加载
Vue.use(VueLazyload, {
  preLoad: 1.3, // 预压高度的比例
  error: "../static/images/1-7-01.jpg", // 图像的加载失败时 显示的error图标
  loading: "../static/images/1-7-01.jpg", // 图像正常加载时 显示的loading图标
  attempt: 2 // 图像尝试加载 次数
});

// 引入全局过滤器
import * as filters from "./static/js/filters";

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

//引入公用css
import "./static/content/css/common.css";
// 引入公用的字体图标文件
import "./static/content/css/fonts.css";
// 引入字体图标js
import "./static/content/js/iconfont";
// swiper CSS
import "swiper/swiper-bundle.css";
// 引入i18n国际化插件
import VueI18n from "vue-i18n";
// 引入iview组件
import iView from "iview";
import "iview/dist/styles/iview.css";
// // 英文
import en from "iview/dist/locale/en-US";
// 中文
import zh from "iview/dist/locale/zh-CN";
// 繁体中文
import zht from "iview/dist/locale/zh-TW";

import request from "./components/request";

Vue.use(VueI18n);
// Vue.use(iView);
// Vue.locale = () => {};

// 导入语言js
import LangEn from "../static/lang/homePage/en.js";
import LangZhCHS from "../static/lang/homePage/zhCHS.js";
import LangZhCHT from "../static/lang/homePage/zhCHT.js";
// import './static/js/https.js'

/**
 * 获取默认的浏览器语言赋予给系统
 * @type {string}
 */
if (window.document.cookie.indexOf("lang") > -1) {
  var browserLang = window.document.cookie.split("lang=")[1].split(";")[0];
  if (!browserLang) {
    browserLang = "zhCHT";
  }
} else {
  var browserLang = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase();
  if (browserLang == "en-us") {
    browserLang = "en";
  } else if (browserLang == "zh-cn") {
    browserLang = "zhCHS";
  } else {
    browserLang = "zhCHT";
  }
}
//  vuei18n实例化
const i18n = new VueI18n({
  //定义默认语言
  locale: browserLang,
  // messages: {
  //   'en': LangEn,
  //   'zhCHS': LangZhCHS,
  //   'zhCHT': LangZhCHT
  // }
  messages: {
    en: Object.assign(LangEn, en),
    zhCHS: Object.assign(LangZhCHS, zh),
    zhCHT: Object.assign(LangZhCHT, zht)
  }
});
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});

/**  只提取汉字--过滤
 *  全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
 */

Vue.filter("GetChinese", function(strValue) {
  if (strValue != null && strValue != "") {
    var strArray = strValue.split("/");

    if (strArray != null && strArray.length > 0) {
      return strArray[0];
    } else {
      return "";
    }
  }
});

// if(!window.document.cookie){
// }else{
// this.str = window.document.cookie;
// this.email = this.str.match(/email(\S*)com/);
// this.jsonstr = JSON.parse(this.str);
// if(this.str){
//   this.showname = true;
// }else{
//   this.showname = false;
// }
// this.str = window.document.cookie
// }
// 注册全局钩子用来拦截导航
// var str = window.document.cookie;
var str = request.getCookie();

// if(!str == '') {

// }else{
//   alert('message')
// }

// if(str){}

/**
 *  过滤订单状态
 */

Vue.filter("ticket", function(str) {
  if (str == "0") {
    str = "等待付款";
  }
  if (str == "1") {
    str = "正在出票";
  }
  if (str == "2") {
    str = "出票成功";
  }
  if (str == "3") {
    str = "正在改签";
  }
  if (str == "4") {
    str = "正在退票";
  }
  if (str == "5") {
    str = "已完成";
  }
  if (str == "6") {
    str = "已结束";
  }
  if (str == "7") {
    str = "已关闭";
  }

  return str;
});

/**
 *  过滤儿童成人类型
 */

Vue.filter("ticketPeple", function(str) {
  if (str == "0") {
    str = "成人";
  }
  if (str == "1") {
    str = "儿童";
  }
  if (str == "2") {
    str = "婴儿";
  }
  return str;
});

Vue.filter("Peple", function(str) {
  if (str == "82") {
    str = "成人";
  }
  if (str == "83") {
    str = "儿童";
  }
  if (str == "84") {
    str = "婴儿";
  }
  return str;
});

Vue.filter("sexuser", function(str) {
  if (str == "0") {
    str = "男";
  }
  if (str == "1") {
    str = "女";
  }
  return str;
});

Vue.filter("documenType", function(str) {
  if (str == "PP") {
    str = "护照";
  }
  if (str == "GA") {
    str = "港澳通行证";
  }
  if (str == "TW") {
    str = "台湾通行证";
  }
  if (str == "TB") {
    str = "台胞证";
  }
  if (str == "HX") {
    str = "回乡证";
  }
  if (str == "HY") {
    str = "国际海员证";
  }
  if (str == "GA") {
    str = "身份证";
  }
  return str;
});

//过滤一次经停
Vue.filter("GetStop1", function(strValue) {
  var strValues;
  if (strValue == true) {
    strValues = 1;
    return strValues;
  }
  if (strValue == false) {
    strValues = "";
    return strValues;
  }
});

//shdhgh/hkf-tf  取hkf
Vue.prototype.RemoteStrl = function(str) {
  if (str != null && str != "") {
    if (str.indexOf("/") <= 0) {
      return str;
    }

    var strArray1 = str.split("/");

    if (strArray1 != null && strArray1.length > 1) {
      var strArray2 = strArray1[1].split("-");

      if (strArray2 != null) {
        return strArray2[0];
      }
    }
  }
  return "";

  /*var index = str.lastIndexOf("\/");
  str = str.substring(index + 1, str.length);
  str = str.slice(0, 3)
  return str*/
};

//截取斜杠前面的TKG/hkf-tf  取TKG
Vue.filter("RemoteStrl", function(str) {
  var index = str.lastIndexOf("/");

  str = str.substring(0, index);
  // str = str.slice(0,3);

  var reg = /^\$\(/gi;
  var reg2 = /\)$/gi;
  str = str.replace(reg, "");
  str = str.replace(reg2, "");
  return str;
});
//去掉汉字
Vue.prototype.RemoteStr = function(strValue) {
  if (strValue != null && strValue != "") {
    var reg = /[\u4e00-\u9fa5]/g;
    return strValue.replace(reg, "").slice(1, 4);
  } else {
    return;
  }
};

//只取数字
Vue.prototype.getNumber = function(strValue) {
  var num = strValue.replace(/[^0-9]/gi, "");
  return num;
};

//去除数字
Vue.prototype.remoteNumber = function(strValue) {
  var regexp = /[0-9]*/g;
  return strValue.replace(regexp, "");
};
// 去掉日期中的斜杠/
Vue.prototype.RemoteSlash = function(strValue) {
  if (strValue != null && strValue != "") {
    return strValue.replace("/", "").replace("/", "");
  } else {
    return;
  }
};

// 航司列表数组中["中国航空CA",]取CA
Vue.prototype.RemoteAirCode = function(strValue) {
  var t = strValue.length;
  for (var i; i < t; i++) {
    var reg = /[a-zA-Z]/g;
    strValue.replace(reg, "");
    // if (strValue[i] != null && strValue != "") {
    //   var reg = /[\u4e00-\u9fa5]/g;
    //   return strValue[i].replace(reg, "");
    // } else {
    //   return
    // }
  }
  return strValue;
};

/**  时间--过滤
 *
 */
//格式化日期格式变成 年 --月 --日 格式--过滤
Vue.filter("GetDate", function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var times =
    d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate() + "";
  return times;
});

Vue.prototype.GetDateBuy = function(time) {
  if (time == "") {
    return;
  }
  // var d = new Date(time);
  // var times = d.getFullYear() + (d.getMonth() + 1) + d.getDate();
  // return times;

  var d = new Date(time);
  var x = d.getMonth() + 1;
  var y = d.getDate();
  if (d.getMonth() + 1 < 10) {
    x = "0" + (d.getMonth() + 1);
  }
  if (d.getDate() < 10) {
    y = "0" + d.getDate();
  }
  var times = d.getFullYear() + "" + x + y;
  return times;
};

Vue.prototype.GetDateBuyss = function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var x = d.getMonth() + 1;
  var y = d.getDate();
  if (d.getMonth() + 1 < 10) {
    x = "0" + (d.getMonth() + 1);
  }
  if (d.getDate() < 10) {
    y = "0" + d.getDate();
  }
  var times = d.getFullYear() + "-" + x + "-" + y;
  return times;
};

// //格式化时间2018-09-13T16:00:00.000Z为2019-09-22，也可以格式话当前时间
Vue.prototype.Getnewdate = function(nowdate) {
  var h = nowdate.getHours();
  var m = nowdate.getMinutes();
  var s = nowdate.getSeconds();
  var d = nowdate.getDate();
  if (h < 10) {
    h = "0" + h;
  }
  if (m < 10) {
    m = "0" + m;
  }
  if (s < 10) {
    s = "0" + s;
  }

  if (d < 10) {
    d = "0" + d;
  }
  var endTime = d + "" + h + "" + m + "" + s;
  return endTime;
};

//格式化日期2018-08-09T16:00Z变成 年 2018-08-09格式--过滤
Vue.filter("GetDates", function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var times = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
  return times;
});

Vue.prototype.GetDatesMults = function(time) {
  if (time == "") {
    return "";
  }
  time = time + "";
  var timesArray = time.split(",");
  var dateArray = [];
  for (var i = 0; i < timesArray.length; i++) {
    var d = new Date(timesArray[i]);
    var x = d.getMonth() + 1;
    var y = d.getDate();
    if (d.getMonth() + 1 < 10) {
      x = "0" + (d.getMonth() + 1);
    }
    if (d.getDate() < 10) {
      y = "0" + d.getDate();
    }
    var times = d.getFullYear() + "" + x + "" + y;
    dateArray[i] = times;
  }
  return dateArray;
};

//时间戳格式化为19990101
Vue.prototype.GetDates = function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var x = d.getMonth() + 1;
  var y = d.getDate();
  if (d.getMonth() + 1 < 10) {
    x = "0" + (d.getMonth() + 1);
  }
  if (d.getDate() < 10) {
    y = "0" + d.getDate();
  }
  var times = d.getFullYear() + "" + x + "" + y;
  return times;
};

//时间戳格式化为1999-01-01
Vue.prototype.GetDatesFormat = function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var x = d.getMonth() + 1;
  var y = d.getDate();
  if (d.getMonth() + 1 < 10) {
    x = "0" + (d.getMonth() + 1);
  }
  if (d.getDate() < 10) {
    y = "0" + d.getDate();
  }
  var times = d.getFullYear() + "-" + x + "-" + y;
  return times;
};

//时间戳格式化为1999-01-01
Vue.prototype.GetDatesSlash = function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var x = d.getMonth() + 1;
  var y = d.getDate();
  if (d.getMonth() + 1 < 10) {
    x = "0" + (d.getMonth() + 1);
  }
  if (d.getDate() < 10) {
    y = "0" + d.getDate();
  }
  var times = d.getFullYear() + "/" + x + "/" + y;
  return times;
};

//将日期 20180825   转换为  -星期-   --过滤
Vue.filter("GetWeek", function(time) {
  var time = parseInt(time);
  var weekDay = [
    "星期天",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六"
  ];
  var d = new Date(time);
  var times = d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();
  var weeks = new Date(times).getDay();
  return weekDay[weeks];
});

//将日期 20180825   转换为  -星期-   --过滤
Vue.filter("GetWeekByLang", function([time, lang]) {
  var weekDayZH = [
    "星期天",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六"
  ];
  var weekDayEN = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];
  var d = new Date(time);
  var times = d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();

  var weeks = new Date(times).getDay();

  if (lang == "en_US") {
    return weekDayEN[weeks];
  } else {
    return weekDayZH[weeks];
  }
});

//格式化日期为  -20180820-  供搜索机票调用--过滤
Vue.filter("GetDateSearch", function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var times = d.getFullYear() + (d.getMonth() + 1) + d.getDate();
  return times;
});

Vue.prototype.GetDateSearch = function(fromTime) {
  var fromTimes =
    fromTime.slice(0, 5) + fromTime.slice(6, 8) + fromTime.slice(8, 10);
  return fromTimes;
};

//格式化日期20190922为2019-09-22
Vue.prototype.GetDateSpace = function(fromTime) {
  var fromTimes =
    fromTime.slice(0, 4) +
    "-" +
    fromTime.slice(4, 6) +
    "-" +
    fromTime.slice(6, 8);
  return fromTimes;
};

//格式化日期为  -20180820-  供搜索机票调用--过滤
Vue.filter("GetDateBuy", function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var times = d.getFullYear() + (d.getMonth() + 1) + d.getDate();
  return times;
});

//格式化日期2019-09-22T115:00为-9月22日-    供搜索机票调用--过滤
Vue.filter("GetDateBuysort", function(time) {
  if (time == "") {
    return;
  }
  var d = new Date(time);
  var x = d.getMonth() + 1;
  var y = d.getDate();
  if (d.getMonth() + 1 < 10) {
    x = "0" + (d.getMonth() + 1);
  }
  if (d.getDate() < 10) {
    y = "0" + d.getDate();
  }
  var times = x + "/" + y + "";
  return times;
});

//格式化时间  将分钟转换成 天和小时  供搜索机票调用--过滤
Vue.filter("GetDateMinute", function(StatusMinute) {
  // var day = parseInt(StatusMinute / 60 / 24);
  // var hour = parseInt(StatusMinute / 60 % 24);
  var hour = parseInt(StatusMinute / 60);
  var min = parseInt(StatusMinute % 60);
  StatusMinute = "";
  // if (day > 0) {
  //   StatusMinute = day + "d ";
  // }
  if (hour > 0) {
    StatusMinute += hour + "h ";
  }
  if (min > 0) {
    StatusMinute += parseFloat(min) + "min ";
  }
  return StatusMinute;
});

// /**  舱位等级--过滤
//  *
//  */
// Vue.filter("CabinGrades", function (str) {
//   if (str == "F") {
//     str = this.$t('message.firstClass')+"(F)";
//   }
//   if (str == "C") {
//     str = this.$t('message.businessClass')+"(C)";
//   }
//   if (str == "S") {
//     str = this.$t('message.premiumEconomyClass')+"(S)";
//   }
//   if (str == "Y") {
//     str = this.$t('message.economyClass')+"(Y)";
//   }

//   return str;

// });
// /**  舱位等级--过滤
//  *
//  */
Vue.filter("CabinGrades", function(str) {
  if (str == "F") {
    str = "舱等" + "(头等舱)";
  }
  if (str == "C") {
    str = "舱等" + "(商务型)";
  }
  if (str == "S") {
    str = "舱等" + "(高端经济舱)";
  }
  if (str == "Y") {
    str = "舱等" + "(经济舱)";
  }

  return str;
});

//实际航司中实际航司名的字符长度>0则该字段存在，格式为MF8501。
Vue.filter("getByteLen", function(val) {
  var len = 0;
  for (var i = 0; i < val.length; i++) {
    var a = val.charAt(i);
    if (a.match(/[^\x00-\xff]/gi) != null) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
});

//取cookie值  先将json对象转换为js对象 取email
Vue.filter("getCookie", function(value) {
  //匹配字段
  if (!value) return "";
  var _value = new Function("", "return " + value)();
  // console.log(_value);
  return _value.email;
  //小坑（1）注意：获取cookie要用window.document.cookie而不能直接document.cookie
});

Vue.prototype.timeTen = function() {
  var second = 0;
  var minute = 0;
  var hour = 0;
  window.setTimeout(interval(), 1000);

  function interval() {
    second++;
    if (second == 60) {
      second = 0;
      minute += 1;
    }
    if (minute == 60) {
      minute = 0;
      hour += 1;
    }
    document.form1.innerHTML = hour + "h " + minute + "min " + second + "s";
    // var t = hour + "时" + minute + "分" + second + "秒";
    //  alert(t)
    window.setTimeout(interval(), 1000);
  }
};
Vue.filter("timeTenMyticket", function(createTimeStr) {
  //今日时间
  var nowdate = new Date().getTime(); //今日的毫秒数
  var createTicket = new Date(createTimeStr); //订单创建的日期转换成时间戳
  var createTicketime = createTicket.getTime(); //订单创建的毫秒数
  var msd = nowdate - createTicketime; //今日  减去  订单    --相差的毫秒数
  var dirsbuy = 60 * 60 * 1000 - msd; //30分钟-相差的时间  倒计时显示的毫秒

  if (msd > 60 * 60 * 1000) {
    // this.istime=false
    return;
  } else {
    // this.istime=true
    var time = parseFloat(dirsbuy) / 1000;
    if (null != time && "" != time) {
      if (time > 60) {
        this.minutes = parseInt(time / 60);
        this.seconds = parseInt(parseFloat(time % 60));
      } else {
        this.minutes = 0;
        this.seconds = parseInt(time);
      }
    } else {
      // time = "00";
    }
    // console.log(this.minutes+"分钟"+this.seconds+"秒")
    // if(this.minutes>=30){
    //   this.istime = false;
    // }else{
    //   this.istime = true;
    //   this.add();
    // }
  }
});

//全局弹窗
// Vue.prototype.timeTen = function () {
//   var second = 0;
//   var minute = 0;
//   var hour = 0;
//   window.setTimeout(interval(), 1000);
//   function interval() {
//     second++;
//     if (second == 60) {
//       second = 0;
//       minute += 1;
//     }
//     if (minute == 60) {
//       minute = 0;
//       hour += 1;
//     }
//    this.timeTenMinute = hour + "时" + minute + "分" + second + "秒";
//     iView.Modal.error({
//       render: (h) => {
//         return h('Input', {
//           props: {
//             value: this.timeTenMinute,
//             autofocus: true,
//             placeholder: 'Please enter your name...'
//           },
//           on: {
//             input: (val) => {
//               this.value = val;
//             }
//           }
//         })
//       }
//     })
//
//     window.setTimeout(interval(),1000);
//   }
//
// }
//取cookie值  先将json对象转换为js对象 取token
// Vue.prototype.RemoteSlashToken = function (value) {
//   //匹配字段
//   if(!value) return '';
//   var  _value =(new Function("","return "+value))();
//   return _value.token;
// };

// //检查cookie
// Vue.prototype.checkCookie = function (strValue) {
//   var user = this.getCookie("userName");
//   if (user != "") {
//     alert("Welcome again " + user);
//   } else {
//     user = prompt("Please enter your name:", "");
//     if (user != "" && user != null) {
//       this.setCookie("userName", user, 365);
//     }
//   }
// };

//生日转化年龄
Vue.prototype.ages = function(str) {
  var r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
  if (r == null) {
    return "";
  }
  var d = new Date(r[1], r[3] - 1, r[4]);
  if (
    d.getFullYear() == r[1] &&
    d.getMonth() + 1 == r[3] &&
    d.getDate() == r[4]
  ) {
    var Y = new Date().getFullYear();
    return Y - r[1];
  }
  return "输入的日期格式错误！";
};

Vue.prototype.curPath = "ticket";
router.beforeEach((to, from, next) => {
  // console.log(to)
  if (
    to.name == "home" ||
    to.name == "bookingTicketTwo" ||
    to.name == "bookingTicketOne" ||
    to.name == "inspectTwo" ||
    to.name == "inspectOne"
  ) {
    Vue.prototype.canChangCurrency = true;
  } else {
    Vue.prototype.canChangCurrency = false;
  }
  // 监听导航栏跳转
  if (
    to.name == "home" ||
    to.name == "bookingTicketTwo" ||
    to.name == "bookingTicketOne" ||
    to.name == "inspectTwo" ||
    to.name == "inspectOne" ||
    to.name == "advanceBooking"
  ) {
    Vue.prototype.curPath = "ticket";
  }
  if (to.path.indexOf("schedule") > -1) {
    Vue.prototype.curPath = "mySchedule";
  }
  if (
    to.name == "contactUs" ||
    to.name == "webDescription" ||
    to.name == "PersonalCenter"
  ) {
    Vue.prototype.curPath = "contactUs";
  }
  next();

  // if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
  //   if (str) { // 通过vuex state获取当前的token是否存在
  //     next()
  //   } else {
  //     // console.log('该页面需要登陆')
  //     next({
  //       path: '/login'
  //       // query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
  //     })
  //   }
  // } else {
  //   next()
  // }
});

var vm = new Vue({
  el: "#app",
  router,
  i18n,
  store,
  components: {
    App
  },
  template: "<App/>"
});

// http返回拦截
axios.interceptors.response.use(
  response => {
    // 响应成功
    if (
      response.data.code == 80100 ||
      response.data.code == 80101 ||
      response.data.code == 80102
    ) {
      request.setCookie("", "", "", "", "", "", "", "", "", "", -1000);
      // var preUrl = window.location.href.split('#')[1];
      vm.$router.push({
        path: "/login",
        query: {
          //preUrl: encodeURIComponent(preUrl)
        }
      });
      //window.location.reload()
    }
    return response;
  },
  error => {}
);

//添加分支测试代码V1.1.X 2018-10-17 15:49



// WEBPACK FOOTER //
// ./src/main.js